import _classCallCheck from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Base } from './Base.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
export var BufferT = /*#__PURE__*/function (_Base) {
  _inherits(BufferT, _Base);
  function BufferT(length) {
    var _this;
    _classCallCheck(this, BufferT);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BufferT).call(this));
    _this.length = length;
    return _this;
  }
  _createClass(BufferT, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length = utils.resolveLength(this.length, stream, parent);
      return stream.readBuffer(length);
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      if (!val) {
        return utils.resolveLength(this.length, null, parent);
      }
      var len = val.length;
      if (this.length instanceof NumberT) {
        len += this.length.size();
      }
      return len;
    }
  }, {
    key: "encode",
    value: function encode(stream, buf, parent) {
      if (this.length instanceof NumberT) {
        this.length.encode(stream, buf.length);
      }
      return stream.writeBuffer(buf);
    }
  }]);
  return BufferT;
}(Base);
export { BufferT as Buffer };